import { couponCodeType } from "./type";

const initialState = {
  coupons: null,
  playersPreview: null,
  playersList: null,
  isLoading: false,
  isPreviewLoading: false,
  isPlayersLoading: false,
  statusCode: null
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case couponCodeType.GET_COUPON_LIST_REQUEST:
      return { ...state, isLoading: true };
    case couponCodeType.GET_COUPON_LIST_SUCCESS:
      return { ...state, isLoading: false, coupons: action.payload.data };
    case couponCodeType.GET_COUPON_LIST_FAIL:
      return { ...state, isLoading: false, error: action.error };

    case couponCodeType.CREATE_COUPON_REQUEST:
      return { ...state, isLoading: true };
    case couponCodeType.CREATE_COUPON_SUCCESS:
      return { ...state, isLoading: false };
    case couponCodeType.CREATE_COUPON_FAIL:
      return { ...state, isLoading: false, error: action.error };

    case couponCodeType.COUPON_PLAYERS_PREVIEW_REQUEST:
      return { ...state, isPreviewLoading: true };
    case couponCodeType.COUPON_PLAYERS_PREVIEW_SUCCESS:
      return { ...state, isPreviewLoading: false, playersPreview: action.payload.data };
    case couponCodeType.COUPON_PLAYERS_PREVIEW_FAIL:
      return { ...state, isPreviewLoading: false, error: action.error };

    case couponCodeType.RESET_COUPON_PLAYERS_PREVIEW:
      return { ...state, playersPreview: null };

    case couponCodeType.GET_COUPON_PLAYERS_LIST_REQUEST:
      return { ...state, isPlayersLoading: true };
    case couponCodeType.GET_COUPON_PLAYERS_LIST_SUCCESS:
      return { ...state, isPlayersLoading: false, playersList: action.payload.data };
    case couponCodeType.GET_COUPON_PLAYERS_LIST_FAIL:
      return { ...state, isPlayersLoading: false, error: action.error };

    default:
      return state;
  }
};
